<template>
  <div class="loading" v-show="visible"></div>
</template>

<script>
export default {
  name: 'loading',
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.loading:before {
  content: '';
  background: url('@/assets/gifs/loading.gif') center center no-repeat;
  background-size: 150px 134px;
  width: 150px;
  height: 134px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -65px;
  margin-top: -65px;
  z-index: 999999;
  opacity: 0.7;
}

.loading:after {
  content: '';
  width: 100%;
  height: 100%;
  line-height: 130px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  /* margin-left: -65px; */
  /* margin-top: 5px; */
  z-index: 99999;
  text-align: center;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.79);
}
</style>
